import { emptyTemplateForm } from './buildTemplatePayload';
import { OPT_OUT_BUTTON_TEXT } from './templateRules';

const MARKETING_FOOTER = 'Para não receber mais, toque em Não quero receber';

const quickReply = text => ({
  type: 'QUICK_REPLY',
  text,
  url: '',
  urlExample: '',
  phoneNumber: '',
  example: '',
});

export const TEMPLATE_LIBRARY = [
  {
    id: 'lembrete_aula',
    category: 'UTILITY',
    name: 'lembrete_aula',
    body: 'Olá {{1}}, lembrete da sua aula de {{2}} hoje às {{3}}. Até já!',
    examples: ['Maria', 'musculação', '18h'],
    footer: '',
    buttons: ['Confirmar', 'Remarcar'],
  },
  {
    id: 'confirmacao_consulta',
    category: 'UTILITY',
    name: 'confirmacao_consulta',
    body: 'Olá {{1}}, sua consulta com {{2}} está marcada para {{3}} às {{4}}. Responda para confirmar.',
    examples: ['Maria', 'Dra. Ana', '14/10', '15h'],
    footer: '',
    buttons: ['Confirmar', 'Preciso remarcar'],
  },
  {
    id: 'cobranca_mensalidade',
    category: 'UTILITY',
    name: 'cobranca_mensalidade',
    body: 'Olá {{1}}, a mensalidade de {{2}} vence em {{3}}. Qualquer dúvida é só responder.',
    examples: ['Maria', 'outubro', '10/10'],
    footer: '',
    buttons: ['Já paguei', 'Falar com atendimento'],
  },
  {
    id: 'aviso_horario',
    category: 'UTILITY',
    name: 'aviso_horario',
    body: 'Olá {{1}}, aviso da {{2}}: {{3}}. Obrigado pela compreensão.',
    examples: ['Maria', 'Academia Forma', 'amanhã abriremos às 8h'],
    footer: '',
    buttons: [],
  },
  {
    id: 'pesquisa_satisfacao',
    category: 'UTILITY',
    name: 'pesquisa_satisfacao',
    body: 'Olá {{1}}, como foi sua experiência na {{2}}? Responda de 1 a 5.',
    examples: ['Maria', 'Academia Forma'],
    footer: '',
    buttons: [],
  },
  {
    id: 'aniversario',
    category: 'MARKETING',
    name: 'aniversario',
    body: 'Parabéns, {{1}}! A {{2}} preparou um presente para você: {{3}}. Vale até {{4}}. Esperamos você!',
    examples: ['Maria', 'Academia Forma', 'uma aula experimental', '31/10'],
    footer: MARKETING_FOOTER,
    buttons: ['Quero meu presente', OPT_OUT_BUTTON_TEXT],
  },
  {
    id: 'reativacao',
    category: 'MARKETING',
    name: 'reativacao',
    body: 'Oi {{1}}, sentimos sua falta na {{2}}! Volte este mês com {{3}}. Esperamos você!',
    examples: ['Maria', 'Academia Forma', 'matrícula grátis'],
    footer: MARKETING_FOOTER,
    buttons: ['Quero voltar', OPT_OUT_BUTTON_TEXT],
  },
  {
    id: 'promocao',
    category: 'MARKETING',
    name: 'promocao',
    body: 'Olá, {{1}}! A {{2}} está com {{3}} até {{4}}. Garanta a sua vaga.',
    examples: ['Maria', 'Academia Forma', '20% de desconto', '31/10'],
    footer: MARKETING_FOOTER,
    buttons: ['Quero saber mais', OPT_OUT_BUTTON_TEXT],
  },
];

export const libraryTemplateForm = id => {
  const item = TEMPLATE_LIBRARY.find(entry => entry.id === id);
  if (!item) return null;
  return {
    ...emptyTemplateForm(),
    name: item.name,
    category: item.category,
    body: item.body,
    bodyExamples: Object.fromEntries(
      item.examples.map((example, index) => [String(index + 1), example])
    ),
    footer: item.footer,
    buttons: item.buttons.map(quickReply),
  };
};
